import React, { useState } from "react";
import { BeatLoader } from "react-spinners";
import { Alert, Button, Col, Form, Input, Row, Switch } from "antd";
import http from "../../../../../services/http";
import { ENTERPRISE_ROLE, LANDING_PAGE_URL } from "../../../../../constant";
import { CurrencyExchange } from "@mui/icons-material";
import { Link } from "react-router-dom";
import Cookie from "js-cookie";
import { toast } from "react-toastify";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleIcon from "../../../../../assets/images/google.png";

const SignupForm = ({ successHandler }) => {
  const [isYearly, setisYearly] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const onGoogleLogin = async (credentialResponse) => {
    const { access_token } = credentialResponse;
    try {
      const { data } = await http.post("google-login", {
        token: access_token,
      });
      Cookie.set("role", "leads");
      Cookie.set("token_leads", data.token);
      Cookie.set("is_logged_once", JSON.stringify(data.is_logged_once));
      Cookie.set("email", data.email);
      if (data.token) localStorage.setItem("modal", 1);
      if (data.is_logged_once === 0) {
        window.location.href = "/set-password";
      } else {
        // TODO: uncomment this when we restrict professional users from accessing enterprise features
        // window.location.href =
        //   data?.role === ENTERPRISE_ROLE ? "/leads" : "/leads/dataset";
        window.location.href = "/leads";
      }
    } catch (err) {
      const { data } = err.response;
      toast.error(data?.error || "Something went wrong, please try again later");
    }
  };
  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: (tokenResponse) => {
      onGoogleLogin(tokenResponse);
    },
    onError: () => {
      console.error("Login Failed");
    },
    flow: "implicit",
    prompt: "select_account",
  });
  const submitHandler = async (values) => {
    setError("");
    setLoading(true);

    const payload = {
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email.trim().toLowerCase(),
      password: values.password,
      password2: values.password,
      // subscription_plan: isYearly ? "yearly" : "monthly",
    };
    http
      .post("register", payload)
      .finally(() => setLoading(false))
      .then(({ data }) => {
        successHandler(data.token, values.password);
      })
      .catch(({ response }) => {
        const error = response?.data?.error ?? {};
        if (typeof error === "string") {
          setError(error.split(":")[1] || error);
          return;
        }
        const fields = Object.entries(error).map(([name, messages]) => ({
          name,
          errors: name === "email" ? ["Email already exist"] : messages,
        }));
        form.setFields(fields);
      });
  };

  return (
    <>
      {error && (
        <Alert
          message={error}
          style={{ width: "100%", textAlign: "center", marginBottom: 20 }}
          type="error"
        />
      )}
      {/* <h3>
        ${isYearly ? "540.00" : "50.00"} /{" "}
        <span> {isYearly ? "year" : "month"}</span>
      </h3>
      <div className="subscription-box">
        <div className="title">
          <CurrencyExchange />
          <h4>Professional</h4>
        </div>
        <div className="plan-selector">
          <span>Monthly</span>
          <Switch onChange={(val) => setisYearly(val)} checked={isYearly} />
          <span>Yearly</span>
        </div>
      </div> */}
      <Form form={form} onFinish={submitHandler}>
        <Row gutter={[24, 0]}>
          <Col xs={12}>
            <label htmlFor="">First name</label>
            <Form.Item
              name="first_name"
              rules={[
                {
                  required: true,
                  message: "Please input your first name!",
                },
                {
                  pattern: /^[a-zA-Z\s]*$/,
                  message: "Please enter valid first name!",
                },
                {
                  max: 30,
                  message: "First name must be less than 30 characters!",
                },
              ]}
            >
              <Input type="text" placeholder="First name" />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <label htmlFor="">Last name</label>
            <Form.Item
              name="last_name"
              rules={[
                {
                  required: true,
                  message: "Please input your last name!",
                },
                {
                  pattern: /^[a-zA-Z\s]*$/,
                  message: "Please enter valid last name!",
                },
                {
                  max: 30,
                  message: "First name must be less than 30 characters!",
                },
              ]}
            >
              <Input type="text" placeholder="Last name" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <label htmlFor="">Email address</label>
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your email!",
                },
                {
                  type: "email",
                  message: "Please enter valid email!",
                },
              ]}
            >
              <Input type="email" placeholder="Email address" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <label htmlFor="">Password</label>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
                {
                  min: 8,
                  message: "Password must be at least 8 characters!",
                },
              ]}
            >
              <Input.Password placeholder="Password" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <label htmlFor="">Confirm password</label>
            <Form.Item
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your confirm password!",
                },
                {
                  min: 8,
                  message: "Password must be at least 8 characters!",
                },
                {
                  validator: (_, value) => {
                    if (
                      !value ||
                      form.getFieldValue("password") === value ||
                      value.length < 8
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("The two passwords that you entered do not match!"),
                    );
                  },
                },
              ]}
            >
              <Input.Password placeholder="Confirm password" />
            </Form.Item>
          </Col>
        </Row>
        <Button className="submit-btn" type="primary" htmlType="submit">
          {isLoading ? <BeatLoader color="#fff" size={8} /> : "Sign Up"}
        </Button>
        <div className="or-seperator">
          <span>Or</span>
        </div>
        <button type="button" className="google-login-btn" onClick={googleLogin}>
          <img src={GoogleIcon} alt="Google" />
          <span>Sign up with Google</span>
        </button>
        <p className="agreement-policy">
          By signing up, you agree to our
          <a target="_blank" href={LANDING_PAGE_URL + "/terms"}>
            Terms of Service
          </a>
          and
          <a target="_blank" href={LANDING_PAGE_URL + "/privacy"}>
            Privacy Policy
          </a>
          .
        </p>
      </Form>
    </>
  );
};

export default SignupForm;
